export function buildMcpSetupInstructions(origin: string, token: string): string {
  const endpoint = `${origin}/mcp`;
  const config = {
    mcpServers: {
      signalsapp: {
        type: "http",
        url: endpoint,
        headers: { Authorization: `Bearer ${token}` },
      },
    },
  };

  return `## Connect to SignalsApp MCP

Server name: signalsapp
Transport: Streamable HTTP
URL: ${endpoint}
Header: Authorization: Bearer ${token}

Portable server configuration:
\`\`\`json
${JSON.stringify(config, null, 2)}
\`\`\`

Setup instructions for you:
1. If SignalsApp MCP is already connected and its tools are available, keep the existing connection and continue.
2. Otherwise, identify the AI client this session is running in and configure this server using that client's supported MCP settings or configuration file. Use the URL and Authorization header above.
3. Preserve all existing client settings and other MCP servers. Add or update only the entry named signalsapp. Do not run commands to create or retrieve a token.
4. Do not print, quote, or send the token anywhere else. It is a secret contained in this message.
5. If the client needs a restart or a new session, tell me exactly what to do. After restart, ask me to paste this same instruction again so you can continue with the context.
6. Once connected, inspect the available tools. Portfolio operations are grouped under the portfolio facade; discover them with list_tools/get_tool and call them through portfolio({ op, ...args }).

Do not claim setup is complete until the SignalsApp tools are visible in this session.`;
}
